/**
 * @author Vaibhav Raut <vaibhav@wemotiveforge.com>
 */

import React from 'react';
import {connect} from 'react-redux';
// import { Form } from '@ant-design/compatible';

// import '@ant-design/compatible/assets/index.css';


import { Form, Button, Input, Layout, Typography, Divider } from 'antd';

import {forgotPasswordRequest} from '../../AuthenticationApiActions';
import './ForgotPassword.css';
import logo from '../../../../assets/logo.png';
import ConstantMessages from '../../../../utils/Strings';
import MessageModal from "../../../../utils/components/MessageModal/MessageModal";
import CustomFooter from "../../../Dashboard/components/CustomFooter/CustomFooter";
// import appLogo from '../../../../assets/icons/genascreen-logo.png'
import appLogo from '../../../../assets/icons/genascreen-logo-white.png'
import { LockOutlined, MailFilled, RedoOutlined } from '@ant-design/icons';
import CustomIcon from '../../../../utils/components/CustomIcon/CustomIcon'

const {Header, Content, Footer} = Layout;
const FormItem = Form.Item;

const fieldValidationRules = {
  email: {
    rules: [
      {type: 'email', message: ConstantMessages.enterValidEmailAddress},
      {required: true, message: ConstantMessages.emailAddressRequired}
    ],
  }
};

/*
 * Form to get the email address from the user and send the verification link to the registered email address
 */
class ForgotPasswordForm extends React.Component {

  /**
   * This method is triggered when form is submitted by the user
   * @param e
   */
  handleSubmit = formData => {
    // e.preventDefault();

    // this.props.form.validateFields((err, formData) => {
      // if (!err) {

        this.props.forgotPassword(formData).then((res) => {
          this.refs.messageModal.setState({
            showModal: true, message: `${res} You will be redirected to the login page.`,
            title: 'Reset Password',
            showOkButton: true,
            handleOk: this.navigateToHome,
            okText: 'Ok'
          });
        });
      // }
    // });
  };
  /**
   * On navigate user to the root path
   */
  navigateToHome = () => {
    window.location = '/';
  };

  constructor(props) {
    super(props);

    this.state = {
      showLoader: false
    };
  }

  /**
   * Render the UI of the forgot password form
   * @returns {XML}
   */
  render() {
    // const {getFieldDecorator} = this.props.form;

    return (
      <Layout className="forgot-password-layout">
        <Header className="forgot-password-header">
          {/* Logo on the Left */}
          <img src={appLogo} alt='Application Logo' style={{ height: '48px' }} />
          <Button className="btn" ghost={true} href="/contact-us">
            Contact
            <CustomIcon name="OpenFolder" />
          </Button>
        </Header>
        <Content className="forgot-password-content">
          <div className='forgot-password-container' style={{ width: '400px', backgroundColor: '#FFFFFF' }}>
            <div className="forgot-password-container-header" >
              {/* <div style={{ textAlign: 'center' }}><img src={appLogo} alt='Application Logo' style={{ height: '60px' }} /></div> */}
              <div className="flex-vertical-gap-1" style={{ alignItems: "center" }}>
                {/* <LockOutlined style={{ fontSize: '32px' }} /> */}
                <CustomIcon name="LockClosed" width={48} height={48} />
                <Typography.Title style={{ margin: 0 }} level={2}>
                  Reset Password
                </Typography.Title>
              </div>
              <Form form={this.props.form} layout="vertical" style={{ width: '100%', padding: '0px', backgroundColor: 'transparent' }} onFinish={this.handleSubmit}>
                <FormItem name="email" label="Email address" rules={fieldValidationRules.email.rules}>
                    <Input placeholder="Enter email address"/>
                </FormItem>
                <FormItem>
                  <Button
                    className="margin-top-2"
                    block
                    type="primary"
                    htmlType="submit"
                  >
                    Request Temporary Password
                    <CustomIcon name="LineArrowRight"/>
                  </Button>
                </FormItem>
                <Divider style={{ margin: 0 }}>OR</Divider>
                <FormItem>
                  <Button
                    className="margin-top-2"
                    block
                    type="primary"
                    href='/signin'
                  >
                    Go to Login
                    <CustomIcon name="LineArrowRight"/>
                  </Button>
                  {/* Or <a href="/signin">go to sign in!</a> */}
                </FormItem>
              </Form>
            </div>
          </div>
          <MessageModal
            ref="messageModal"
          />
        </Content>
      </Layout>
    );
  }
}

let ForgotPassword = (props) => {
  const [form] = Form.useForm();
  return <ForgotPasswordForm form={form} {...props} />;
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    forgotPassword: (data) => {
      return dispatch(forgotPasswordRequest(data)).then((res) => {
        return Promise.resolve(res);
      }, (error) => {
        return Promise.reject(error);
      });
    }
  }
};

ForgotPassword = connect(
  null,
  mapDispatchToProps
)(ForgotPassword);

export default ForgotPassword;
